<template>
  <section>
    <div class="player">
      <header>{{deviceName}}</header>
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
    </div>
  </section>
</template>

<script>
  import { getLiveApi } from '@/api/video'
  import { videoPlayer } from 'vue-video-player';
  export default {
    components: {
      videoPlayer
    },
    data() {
      return {
        sn: this.$route.query.sn,
        deviceName:'',//设备名称
        playerOptions: {
          //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: "application/x-mpegURL",
            src: "http://hls01open.ys7.com/openlive/8c925c2dd82c4649b4f58c842813b048.m3u8" //你的m3u8地址（必填）
          }],
          poster: "poster.jpg", //你的封面地址
          //width: document.documentElement.clientWidth,
          //height:document.documentElement.clientHeight,
          notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          //  controlBar: {
          //   timeDivider: true,
          //   durationDisplay: true,
          //   remainingTimeDisplay: false,
          //   fullscreenToggle: true //全屏按钮
          //  }
        }
      }
    },
    created() {
      console.log(this.sn);
      this.getLiveUrl()

    },
    methods: {
      //异步获取直播地址
      getLiveUrl() {
        getLiveApi({sn:this.sn}).then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.deviceName = res.data.data.deviceName;
            this.playerOptions.sources[0].src=res.data.data.hdAddress;
          }
          else {
            this.$message({type: 'error', message: res.msg});
          }
        })
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .player{
    width: 70%;
    //height: 300px;
    margin: 2% auto auto auto;
    padding: 1% 2% 2% 2%;
    border-radius: 5px;
    background-color: rgba(0,0,0,.2);
    header{
      padding-bottom: 1%;
      font-weight: bold;
      color: #343434;
    }
  }
</style>
